import React from 'react';
import { Chip, CircularProgress } from '@mui/material';

/**
 * FilterPill
 * Touch-friendly pill chip for quick-filter strips.
 */
function FilterPill({ label, icon, active, loading, onClick, hasPopover, ariaLabel }) {
  return (
    <Chip
      label={label}
      icon={loading ? <CircularProgress size={14} color="inherit" /> : icon}
      variant={active ? 'filled' : 'outlined'}
      color={active ? 'primary' : 'default'}
      clickable
      onClick={onClick}
      aria-pressed={active}
      aria-label={ariaLabel || label}
      {...(hasPopover ? { 'aria-haspopup': 'true' } : {})}
      sx={{
        height: 36,
        fontWeight: 600,
        borderRadius: 999,
        flexShrink: 0,
        px: 0.5,
        ...(active
          ? { color: 'common.white' }
          : { bgcolor: 'background.paper' }),
      }}
    />
  );
}

export default FilterPill;
